var map = {
	"./data/data": "dd8b",
	"./data/data.json": "dd8b",
	"./icon-arrow-down.svg": "0aef",
	"./icon-arrow-left.svg": "9ef1",
	"./icon-arrow-right.svg": "c43b",
	"./icon-calendar.svg": "67cb",
	"./icon-check.svg": "c25b",
	"./icon-delete.svg": "7345",
	"./icon-moon.svg": "ecb1",
	"./icon-plus.svg": "d0d5",
	"./icon-sun.svg": "1e89",
	"./illustration-empty.svg": "952f",
	"./image-avatar.jpg": "6286",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";